export default {
  methods: {
    mapLayerTopolinesContours5mAdd() {
      this.map.addSource("topolines-contours5m-source", {
        type: "vector",
        tiles: [
          "https://storage.googleapis.com/map-tiles-wbsnow/5m_contours/{z}/{x}/{y}.pbf"
        ],
        maxzoom: 20,
        minzoom: 13
      });

      this.map.addLayer({
        id: "topolines-contours5m-line",
        source: "topolines-contours5m-source",
        "source-layer": "5mcontours",
        type: "line",
        paint: {
          "line-color": "white",
          "line-opacity": 0.5,
          "line-width": 1
        }
      });

      this.map.addLayer({
        id: "topolines-contours5m-labels",
        type: "symbol",
        source: "topolines-contours5m-source",
        "source-layer": "5mcontours",
        layout: {
          "symbol-placement": "line",
          "symbol-spacing": 250,
          "symbol-avoid-edges": false,
          "text-font": ["Open Sans Bold"],
          "text-field": "{altitude}m",
          "text-size": 12,
          "text-allow-overlap": true,
          "text-letter-spacing": 0.1
        },
        paint: {
          "text-color": "white"
          // "text-halo-color": "#FFFFFF",
          // "text-halo-width": 3
        }
      });

      this.map.moveLayer("topolines-contours5m-labels", "marker-layer-lines");
      this.map.moveLayer("topolines-contours5m-line", "marker-layer-lines");
    },
    mapLayerTopolinesContours5mRemove() {
      this.map.removeLayer("topolines-contours5m-line");
      this.map.removeLayer("topolines-contours5m-labels");
      this.map.removeSource("topolines-contours5m-source");
    }
  },
  computed: {
    computedTopolinesContours5mMapVisibility() {
      return this.$store.state.mapLayers.topolines.layers.contours5m.visibility
        .mapView;
    }
  },
  watch: {
    "$store.state.mapLayers.topolines.layers.contours5m.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerTopolinesContours5mAdd();
      } else {
        this.mapLayerTopolinesContours5mRemove();
      }
    }
  }
};
